export default __webpack_public_path__ + "static/media/nubCon1.2caed843.png";